import script from "./Github.vue?vue&type=script&setup=true&lang=js"
export * from "./Github.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__